module.exports = __webpack_public_path__ + "static/venngage-logo-3529abf42c878835e5cfee1eb82b9da9.png";